import { observer } from "mobx-react-lite";
import { useState,useEffect } from "react";
import {useNavigate} from "react-router-dom";
import CategoryListComponent from "./categories/CategoryListComponent";
import AboutUsPage from "../../features/home/AboutUsPage";
import ResponsiveProductPage from "./categories/ResponsiveProductPage";
import useEmblaCarousel from 'embla-carousel-react';
import AboutUsComponent from './AboutUsComponent';
import NumbersComponent from "./NumbersComponent";
import PoliciesComponent from "./PoliciesComponent";
import CustomerReviewsComponent from "./CustomerReviewsComponent";
import ProductGalleryComponent from "./product/ProductGalleryComponent";
import FeatureProductGalleryComponent from "./product/FeatureProductGalleryComponent";
import { Category } from "../../app/models/category";
import ProductSearch from "./product/ProductSearch";
import {useStore} from "../../app/stores/rootStore";

export default observer(function ResponsiveHomePage() {
    const [toggleBtn, setToggleBtn] = useState(true);
    const navigate = useNavigate();
  const toggle = () => setToggleBtn(val => !val);
  const { commonStore,modalStore,parentCategoryStore,productsStore} = useStore();    
    const currentyear = new Date().getFullYear();
    const randomNumberInRange = (min, max) => { 
      return Math.floor(Math.random()  
              * (max - min + 1)) + min; 
  };    
  const {isLoaded,productByName,loadAll,setItemload} = productsStore;
  const {resetSelectedItem} = parentCategoryStore;
  const options = { align: 'start' }
  const [emblaRef, emblaApi] = useEmblaCarousel(options)
  useEffect(() => {    
    if(!isLoaded)
    {
        resetSelectedItem();
        loadAll().then(()=>{
            setItemload(true);
        })
    }
  },[isLoaded])
    return (
        <>
<ProductSearch />
<section data-bs-version="5.1" className="header02 markm5 cid-uATJnUXB5t" id="header02-e">
    <div className="container">
        <div className="row">
            <div className="col-12 col-lg-7 card">
                <div className="title-wrapper">
                    <h1 className="mbr-section-title mbr-fonts-style display-1">Discover the Elegance of Chanderi & Maheshwari Sarees</h1>
                    <h3 className="mbr-section-subtitle mbr-fonts-style display-5" style={{color:"white"}}>
                    Stylish & Timeless Collections by Voguish Trendy Couture for Every Occasion
                    </h3>
                    <div className="mbr-section-btn"><a className="btn btn-info-outline display-4" onClick={()=>{                                                                       
                            navigate(`/catalog`);
                        }} >
                            BUY NOW
                        </a>                        
                        </div>
                </div>
            </div>            
            <div className="col-12 col-lg-5 card">
                <div className="image-wrapper">                    
                    <video  controls autoPlay={true} loop muted>
        <source src="assets/images/chanderi-saree-collections.mp4" type="video/mp4" />
        Your browser does not support the video tag.
              </video>
                </div>
            </div>
        </div>
    </div>
</section>
<AboutUsComponent />
<CategoryListComponent isChildView={false} />
<FeatureProductGalleryComponent title="New Arrivals" />
<NumbersComponent />
<PoliciesComponent />
<CustomerReviewsComponent />
        </>
    )
})